export const PurchaseModalEvents = {
  SubmitPurchaseRequest: 'SubmitPurchaseRequest',
};
